/**
 * Flow B · search routes — WP-C.
 *
 * B2 `/search` · B3 `/search?q=` · B4 `/search/voice`
 *
 * B2 and B3 are one route. The manifest lists them separately because the harness needs
 * a URL per frame, but they are the same screen in two states of the same query string,
 * and splitting them into two paths would make the empty state a place you can navigate
 * to instead of a place you start.
 *
 * App.tsx mounts this array; it is not edited from here.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { SearchScreen } from './search.js';
import { VoiceScreen } from './voice.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (discovery · আবিষ্কার); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const searchRoutes: RouteObject[] = withSurfaceStates('discovery', [
  { path: '/search', element: <SearchScreen /> },
  { path: '/search/voice', element: <VoiceScreen /> },
]);
